<template>
    <div>
        <div v-if="type !== 'replace_existing'" :id="'device_form_' + type" class="col-sm-4">
            <div class="vrm-form__image-select" :class="{ active: selectedDevice === type }">
                <div class="vrm-form__image-select__img" :class="type">
                    <img
                        :src="'/img/svg-icons/' + type + '.svg'"
                        :alt="deviceData.name"
                        :title="deviceData.name"
                    />
                </div>
                <div class="vrm-form__image-select__text" v-html="deviceData.name"></div>
            </div>
        </div>
        <div v-else class="replace-gx">
            <div class="col-sm-12 text-section">
                <h2
                    v-html="
                        $t(`addinstallation.replace_gx_title`, {
                            i18nFallback: 'Replace an existing GX device',
                        })
                    "
                ></h2>
                <p
                    v-html="
                        $t(`addinstallation.use_this_option_description`, {
                            i18nFallback:
                                ' Use this option to replace an old GX device with a new one, and transfer the site history.',
                        })
                    "
                ></p>
            </div>
            <div :id="'device_form_' + type" class="col-sm-4 register">
                <div class="vrm-form__image-select" :class="{ active: selectedDevice === type }">
                    <div class="vrm-form__image-select__img" :class="type">
                        <img
                            :src="'/img/svg-icons/' + type + '.svg'"
                            :alt="deviceData.name"
                            :title="deviceData.name"
                        />
                    </div>
                    <div class="vrm-form__image-select__text" v-html="deviceData.name"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

@Component({
    data: function() {
        return {};
    },
    props: {
        type: { type: String, default: null },
        deviceData: { type: Object, default: null },
        selectedDevice: { type: String, default: null },
    },
    created() {},
})
@AngularDirective('vrm-add-installation-header')
@AngularLocaleBundle('addinstallation')
export default class VrmAddInstallationHeader extends Vue {}
</script>
